<template>
    <div>
        <div class="container-fluid picking-list" v-cloak>
            <legend>ショップメニューマスタ</legend>

            <div class="text-end">
                <button type="button" class="btn btn-outline-info mb-3" @click="edit()">
                    <TablerIcon name="IconPlus" :size="18" />
                    新規作成
                </button>
            </div>

            <div class="container">
                <transition mode="out-in">
                    <draggable @end="onEnd($event)" item-key="no" tag="div" :list="shop_menus">
                        <template #item="{ element }">
                            <div class="card my-3" :key="element && element.no" :class="{ 'deleted': element.deleted_at }">
                                <div class="card-body">
                                    <div class="d-flex justify-content-between">
                                        <div class="d-flex justify-content-start align-items-center">
                                            <button class="btn btn-outline-secondary btn-sm me-3" @click="edit(element.id)">
                                                <TablerIcon name="IconEdit" :size="18" />
                                                編集
                                            </button>
                                            <h3 class="card-title mb-0">
                                                {{ element.menu_name }}
                                            </h3>
                                        </div>
                                        <div>
                                            <button class="btn btn-warning btn-sm" @click="toggle(element)" v-if="!element.deleted_at">
                                                <TablerIcon name="IconTrash" :size="18" />
                                                削除
                                            </button>
                                            <button class="btn btn-outline-success btn-sm" @click="toggle(element)" v-else>
                                                <TablerIcon name="IconRotateClockwise" :size="18" />
                                                復元
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                </transition>
            </div>

            <shop-menus-editor
                id="shop-menus-editor"
                :shop_menu_id="shop_menu_id"
                @save="reload()"
                @mounted="modalMounted($event)"
                @close="closeModal($event)">
            </shop-menus-editor>
        </div>
    </div>
</template>

<script>
import shopMenusEditor from "./shopMenusEditor.vue";
import draggable from "vuedraggable";

export default {
    components: {
        shopMenusEditor,
        draggable
    },
    data: () => ({
        shop_menu_id: null,
        isLoading: false,
        shop_menus: [],
        modals: []
    }),

    methods: {
        reload() {
            this.isLoading = true;
            axios.get("/master/shop_menus/lists").then(res => {
                this.shop_menus = res.data;
            }).catch(err => {
                Alert.err(err.response);
            }).finally(() => this.isLoading = false);
        },

        edit(id = null) {
            this.shop_menu_id = id;
            setTimeout(() => {
                this.modals["shop-menus-editor"].show();
            });
        },

        toggle(v) {
            let action = "復帰";
            let type = "info";
            let mode = false;

            if (!v.deleted_at) {
                action = "削除";
                type = "warning";
                mode = true;
            }

            swal({
                title: `ショップメニューマスタ${action}`,
                text: `指定のレコードを${action}します。\nよろしいですか？`,
                icon: type,
                buttons: ["キャンセル", action],
                dangerMode: mode
            }).then(will_delete => {
                if (will_delete) {
                    axios.post("/master/shop_menus/toggle", { id: v.id }).then(res => {
                        this.reload();
                        Alert.msg(res.data);
                    }).catch(err => {
                        Alert.err(err.response);
                    });
                }
            });
        },

        onEnd() {
            this.shop_menus.map((shop, length) => {
                shop.order_number = length + 1;
                return { shop };
            });

            this.isLoading = true;
            axios.post("/master/shop_menus/dragsort", { shop_menus: this.shop_menus }).then(() => {
                this.reload();
            }).catch(err => {
                Alert.err(err.response);
            }).finally(() => this.isLoading = false);
        },

        modalMounted(id) {
            this.modals[id] = new bootstrap.Modal(document.getElementById(id));
        },

        closeModal() {
            this.reload();
        }
    },

    mounted() {
        this.reload();
    }
};
</script>
